import { useExperiments } from '@wix/fe-essentials-standalone';
import { ENABLE_SCHEDULE_MEETING_BUTTON } from '@utils/constants';

export const useScheduleMeetingButton = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isScheduleMeetingButtonEnabled = experiments.enabled(
    ENABLE_SCHEDULE_MEETING_BUTTON,
  );

  return { isScheduleMeetingButtonEnabled };
};
